import styles from "./index.module.scss";
import Image from "next/image";

export default function ThreeColumnFeatureGrid({data}) {

  const title = data?.title || "";
  const items =
    data?.cards?.map(card => {
      const imageFields = card?.fields?.image?.fields;
      return {
          id: card?.sys?.id,
          title: card?.fields?.title,
          description: card?.fields?.description,
          image: imageFields.assets?.[0]?.fields?.file?.url
          ? `https:${imageFields.assets[0].fields.file.url}`
          : imageFields.imageUrl,
      }}) || [];

  return (
    <section className={styles.whyChooseUs}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h2>{title}</h2>
        </div>
        <div className={styles.grid}>
          {items.map((item) => (
            <div key={item.id} className={styles.card}>
              <figure>
                <div className={styles.imageWrapper}>
                  <Image
                    src={item.image}
                    alt={item.title}
                    fill
                  />
                </div>
                <figcaption>
                  <h3 className={styles.cardTitle}>{item.title}</h3>
                  <p className={styles.cardDesc}>{item.description}</p>
                </figcaption>
              </figure>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

